module.exports = __webpack_public_path__ + "static/img/weixin_qrcode.89b0a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin/weixin_qrcode.png
// module id = oIKC
// module chunks = 4